import { Link, useLocation } from "react-router-dom";
import { Images, MessageSquareQuote, LogOut, Settings, CalendarDays } from "lucide-react";

export default function AdminNav({ onLogout }) {
  const { pathname } = useLocation();

  const tabs = [
    { to: "/admin", icon: Images, label: "Gallery" },
    { to: "/admin/bookings", icon: CalendarDays, label: "Bookings" },
    { to: "/admin/reviews", icon: MessageSquareQuote, label: "Reviews" },
    { to: "/admin/site", icon: Settings, label: "Site" },
  ];

  const isActive = (to) =>
    to === "/admin" ? pathname === "/admin" || pathname === "/admin/gallery" : pathname === to;

  return (
    <header className="border-b border-[#262626] bg-[#050505] sticky top-0 z-40 backdrop-blur">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between gap-6 flex-wrap">
        <div className="flex items-baseline gap-3">
          <span className="font-serif text-2xl text-white">Overdrive</span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#D6B98D]">Admin</span>
        </div>

        <nav className="flex items-center gap-1 order-3 md:order-2 w-full md:w-auto">
          {tabs.map((t) => {
            const Icon = t.icon;
            const active = isActive(t.to);
            return (
              <Link
                key={t.to}
                to={t.to}
                data-testid={`admin-nav-${t.label.toLowerCase()}`}
                className={`inline-flex items-center gap-2 px-4 py-2.5 text-xs uppercase tracking-[0.25em] rounded-sm transition-all ${
                  active
                    ? "bg-[#D6B98D] text-[#050505] font-bold"
                    : "text-white/60 hover:text-[#D6B98D] border border-transparent hover:border-[#262626]"
                }`}
              >
                <Icon className="w-3.5 h-3.5" /> {t.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-4 order-2 md:order-3">
          <a
            href="/"
            className="text-xs uppercase tracking-[0.25em] text-white/50 hover:text-[#D6B98D] transition-colors"
          >
            View site
          </a>
          <button
            onClick={onLogout}
            data-testid="admin-logout-button"
            className="inline-flex items-center gap-2 px-4 py-2 border border-[#262626] hover:border-[#D6B98D] hover:text-[#D6B98D] text-xs uppercase tracking-[0.25em] text-white/70 transition-all rounded-sm"
          >
            <LogOut className="w-3.5 h-3.5" /> Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
